module.exports = __webpack_public_path__ + "static/media/speech_11.6af0aad2.svg";